import { api } from "api/apiService";

/**
 * Завантажує повний список постачальників.
 * @returns {Promise<Array>} Проміс, що повертає масив з об'єктами постачальників.
 */
export const fetchSuppliers = () => {
  return api.get("/suppliers");
};

/**
 * Оновлює дані для конкретного постачальника.
 * @param {number|string} supplierId - ID постачальника, якого потрібно оновити.
 * @param {object} data - Об'єкт з полями для оновлення (напр., { markup: 1.25 }).
 * @returns {Promise<object>} Проміс, що повертає відповідь від сервера.
 */
export const updateSupplier = (supplierId, data) => {
  return api.put(`/suppliers/${supplierId}`, data);
};
